import { render, staticRenderFns } from "./AssessStatistics.vue?vue&type=template&id=6a8a89c2&scoped=true&"
import script from "./AssessStatistics.vue?vue&type=script&lang=js&"
export * from "./AssessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AssessStatistics.vue?vue&type=style&index=0&id=6a8a89c2&scoped=true&lang=scss&"
import style1 from "./AssessStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a89c2",
  null
  
)

export default component.exports